import { styled } from '@mui/material/styles';

import { ScreenSize } from '../../../@types';
import { COLORS } from '../../../configs/colors';

export const Root = styled('div')`
  display: flex;

  @media ${ScreenSize.MOBILE} {
    display: inline;
  };

`;

export const OutletWrapper = styled('div')`
  flex: 1;
  min-width: 0;
  background-color: ${COLORS.OffWhite};
  overflow-x: clip;
  zoom: 1.1;
`;
